<template>
  <div class="content p-5">
    <!-- <h2> Page Not Found </h2>
    <router-link to="/">
      <div class="go-here px-3 py-2 my-4" ref="GoBox">
        <h4>
          หน้าแรก
        </h4>
      </div>
    </router-link> -->
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  data () {
    return {
      top_height: 0
    }
  },
  methods: {
    matchHeight () {
      this.top_height = this.$parent.$refs.TopBox.clientHeight
    }
  },
  mounted () {
    this.$router.push({ name: 'Home' })
  }
}
</script>

<style scoped>
.go-here {
  color: white;
  background: #005eac;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 100px;
  position: absolute;
  z-index: 10;
  left: 40%;
}
</style>
